import React, { useEffect, useState } from "react";
import { collection, addDoc, getDocs, doc, updateDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";

export default function OverheadSettings(){
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ name:"", amount:"", frequency:"monthly", active:true, startDate:"", endDate:"" });

  const load = async () => {
    const snap = await getDocs(collection(db, "overheadSettings"));
    setItems(snap.docs.map(d => ({ id:d.id, ...d.data() })));
  };

  useEffect(() => { load(); }, []);

  const add = async () => {
    const payload = {
      name: form.name.trim(),
      amount: Number(form.amount)||0,
      frequency: form.frequency,
      active: !!form.active,
      ...(form.startDate ? {startDate: form.startDate} : {}),
      ...(form.endDate ? {endDate: form.endDate} : {})
    };
    if (!payload.name) return alert("Name required");
    await addDoc(collection(db, "overheadSettings"), payload);
    setForm({ name:"", amount:"", frequency:"monthly", active:true, startDate:"", endDate:"" });
    load();
  };

  const toggle = async (id, active) => {
    await updateDoc(doc(db, "overheadSettings", id), { active: !active });
    load();
  };

  return (
    <div style={{padding:16, maxWidth:800, margin:"0 auto"}}>
      <h2>Overhead Settings</h2>
      <div className="form-container">
        <label>Name</label>
        <input value={form.name} onChange={e=>setForm({...form, name:e.target.value})}/>
        <label>Amount ($)</label>
        <input type="number" value={form.amount} onChange={e=>setForm({...form, amount:e.target.value})}/>
        <label>Frequency</label>
        <select value={form.frequency} onChange={e=>setForm({...form, frequency:e.target.value})}>
          <option value="daily">Daily</option>
          <option value="weekly">Weekly</option>
          <option value="monthly">Monthly</option>
          <option value="yearly">Yearly</option>
        </select>
        <label>Start (optional)</label>
        <input type="date" value={form.startDate} onChange={e=>setForm({...form, startDate:e.target.value})}/>
        <label>End (optional)</label>
        <input type="date" value={form.endDate} onChange={e=>setForm({...form, endDate:e.target.value})}/>
        <div>
          <label><input type="checkbox" checked={form.active} onChange={e=>setForm({...form, active:e.target.checked})}/> Active</label>
        </div>
        <button className="green-button" onClick={add}>Add Overhead</button>
      </div>

      <div className="table-container" style={{ overflowX: 'auto', marginTop:16 }}>
        <table>
          <thead>
            <tr><th>Name</th><th>Amount</th><th>Freq</th><th>Active</th><th>Start</th><th>End</th><th>Toggle</th></tr>
          </thead>
          <tbody>
            {items.map(x=>(
              <tr key={x.id}>
                <td>{x.name}</td>
                <td>${x.amount.toFixed?.(2) ?? x.amount}</td>
                <td>{x.frequency}</td>
                <td>{x.active ? "Yes" : "No"}</td>
                <td>{x.startDate || ""}</td>
                <td>{x.endDate || ""}</td>
                <td><button className="yellow-button" onClick={()=>toggle(x.id, x.active)}>{x.active ? "Disable" : "Enable"}</button></td>
              </tr>
            ))}
            {items.length===0 && <tr><td colSpan={7} style={{textAlign:"center"}}>No overhead items yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
